module.exports = __webpack_public_path__ + "img/UAE-landscape-english.6d22fa04.png";